import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import Table from "../../components/table/Table";
import Selector from "../../components/dropdown/commonDropdown/Selector";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import ActionDeleteButton from "../../components/UIComponent/ActionTableComponent/ActionDeleteButton";
import ActionTagButton from "../../components/UIComponent/ActionTableComponent/ActionTagButton";
import SwalServices from "../../services/swalServices/SwalServices";
import EntryManagementServices from "../../services/axiosServices/apiServices/EntryManagementServices";
import moment from "moment";
import {
  CommonSuccessMessages,
  CommonValidationMessages,
  ErrorMessage,
  SuccessMessage,
} from "../../utils/Messages";
import DropdownAction from "../../components/dropdown/DropdownAction";
import CancelAllBookingsModel from "../../components/entrymanagement/CancelAllBookingsModel";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import { encryptAES } from "../../utils/Encryption";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import { saveAs } from "file-saver";
import { WebPath } from "../../utils/AppSetting";
import EventCalender from "../../components/eventCalander/EventCalender";
import ToggleButton from "../../components/common/ToggleButton";
import * as XLSX from "xlsx";
import ConfirmationModal from "../../components/common/buttonLoader/ConfirmationModel";

import CommonServices from "../../services/axiosServices/apiServices/CommonServices";
import UploadBookingReports from "../../components/entrymanagement/UploadBookingReports";
import EventDropDownAction from "../../components/dropdown/EventDropDownAction";
import { getAuditContext } from "../../utils/AuthenticationLibrary";

export default class ViewEditEntries extends Component {
  constructor(props) {
    super(props);
    this.swalServices = new SwalServices();
    this.entryServices = new EntryManagementServices();
    this.financeService = new FinanceServices();
    this.BookingServices = new BookingServices();

    this.CommonServices = new CommonServices();
    this.entryManagementServices = new EntryManagementServices();
    this.state = {
      route: "",
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        statusId: 0,
        optionSelected: [],
        hiddenSearch: "",
        isCalendarView: true,
        eventCertificateType: 0
      },
      fileDetails: {
        fileName: "",
        fullFilePath: ""
      },
      totalResultes: "",
      isLoading: false,
      eventList: [],
      eventStatus: [],
      hiddenOption: [
        {
          value: 1,
          label: "Yes",
        },
        {
          value: 2,
          label: "No",
        },
      ],
      eventId: 0,
      actionDropdownsendCertificate: [
        "Edit",
        // "Cancel all bookings",
        "Upload Booking Reports",
        "Download Booking Reports",
        "URL Link",
        "Send Certificate"
      ],
      actionDropdown: [
        "Edit",
        // "Cancel all bookings",
        "Upload Booking Reports",
        "Download Booking Reports",
        "URL Link",
      ],
      actionDropdownsendCertificate3: [
        "Edit",
        // "Cancel all bookings",
        "Upload Booking Reports",
        "Download Booking Reports",
        "Send Certificate"
      ],
      actionDropdown3: [
        "Edit",
        // "Cancel all bookings",
        "Upload Booking Reports",
        "Download Booking Reports",
      ],
      actionDropdown2: ["Edit"],
      setCancelAllBookingsModel: false,
      setUploadBookingReports: false,
      uploadBookingReports: {},
      uploadReport: [],
      cancelBookingDetails: {},
      cancellationReason: [],
      gstRate: 0,
      isOtherCancellationReason: false,
      cancelBookingDetailsValidationRules: {
        cancellationReasonId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "cancellation reason"
            ),
          },
        ],
        cancellationReason: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "cancellation reason"
            ),
          },
        ],
      },
      validCreditNote: {
        isValid: true,
        error: {},
      },
      confirmModalOpen: false,
      selectedEvent: null,
      isSendingCertificates: false,
    };
  }

  // Methods Section
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {
      this.getEntryDetailList(newPagination);
    });

  };

  actions = (element, index, value) => {
    if (element !== "eventId") return null;

    const currentEvent = this.state.eventList.find((x) => x.eventId === value);
    if (!currentEvent) return null;

    // Decide base options array
    let options = [];

    const isApproved = currentEvent.status === "Approved ";
    const isFutureDate = new Date(currentEvent.eventDate).getTime() >= new Date().getTime();
    const hasCertificate = currentEvent.eventCertificateType !== 1;

    if (isApproved && isFutureDate) {
      options = hasCertificate
        ? [...this.state.actionDropdownsendCertificate]
        : [...this.state.actionDropdown];
    } else if (isApproved) {
      options = hasCertificate
        ? [...this.state.actionDropdownsendCertificate3]
        : [...this.state.actionDropdown3];
    } else {
      options = [...this.state.actionDropdown2];
    }
    if (!currentEvent.booking || Number(currentEvent.booking) === 0) {
      options = options.filter(opt => opt !== "Upload Booking Reports");
    }

    return (
      <td>
        <ActionContainer>
          <EventDropDownAction
            key={index}
            value={value}
            value2={this.state.eventList[index].eventTimeSlotId}
            id={index}
            index={index}
            options={options}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
          <ActionTagButton
            value={value}
            id={index}
            index={index}
            onActionClick={this.onTagging.bind(this)}
          />
          <ActionDeleteButton
            value={value}
            value2={this.state.eventList[index].eventTimeSlotId}
            id={index}
            index={index}
            onActionClick={this.onDelete.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };


  // actions = (element, index, value) => {
  //   return element !== "eventId" ? null : (
  //     <td>
  //       <ActionContainer>
  //         {this.state.eventList.find((x) => x.eventId === value).status ===
  //           "Approved " &&
  //           new Date(
  //             this.state.eventList.find((x) => x.eventId === value).eventDate
  //           ).getTime() >= new Date().getTime() ? (
  //           <DropdownAction
  //             key={index}
  //             value={value}
  //             id={index}
  //             index={index}
  //             // options= {this.state.eventList.eventCertificateType !== 1 ? ({this.state.actionDropdown}) : " " }
  //             options={this.state.eventList.find((x) => x.eventId === value).eventCertificateType !==
  //               1 ? this.state.actionDropdownsendCertificate : this.state.actionDropdown}
  //             align="right"
  //             onOptionClick={this.actionClick.bind(this)}
  //           />
  //         ) : this.state.eventList.find((x) => x.eventId === value).status ===
  //           "Approved " ? (
  //           <DropdownAction
  //             key={index}
  //             value={value}
  //             id={index}
  //             index={index}
  //             options={this.state.eventList.find((x) => x.eventId === value).eventCertificateType !==
  //               1 ? this.state.actionDropdownsendCertificate3 : this.state.actionDropdown3}
  //             //options={this.state.pagination.eventCertificateType !== 1 ? this.state.actionDropdown : []}
  //             align="right"
  //             onOptionClick={this.actionClick.bind(this)}
  //           />
  //         ) : (
  //           <DropdownAction
  //             key={index}
  //             value={value}
  //             id={index}
  //             index={index}
  //             options={this.state.actionDropdown2}
  //             align="right"
  //             onOptionClick={this.actionClick.bind(this)}
  //           />
  //         )}
  //         {/* <ActionEditButton
  //         value={value}
  //         id={index}
  //         index={index}
  //         onActionClick={this.onEdit.bind(this)}
  //         text="Edit"
  //       /> */}
  //         <ActionTagButton
  //           value={value}
  //           id={index}
  //           index={index}
  //           onActionClick={this.onTagging.bind(this)}
  //         // text="Edit"
  //         />
  //         <ActionDeleteButton
  //           value={value}
  //           value2={this.state.eventList[index].eventTimeSlotId}
  //           id={index}
  //           index={index}
  //           onActionClick={this.onDelete.bind(this)}
  //         // text="Delete"
  //         />
  //       </ActionContainer>
  //     </td>
  //   );
  // };

  handleChangeInDropdown(selected, drpIdentity) {
    if (drpIdentity === "Status") {
      let details = this.state.pagination;
      details["optionSelected"] = selected;
      details.pageNo = 1;
      details.pageSize = 10;
      details.statusId = selected.value;
      this.setState({ pagination: details });
    }
    if (drpIdentity === "Hidden") {
      let details = this.state.pagination;
      details.pageNo = 1;
      details.pageSize = 10;
      if (selected.value > 0) {
        details.hiddenSearch = selected.label;
      } else {
        details.hiddenSearch = "";
      }
      this.setState({ pagination: details });
    }
  }



  componentDidMount() {
    this.getAllDropDownForEntryManagement(this.state.eventId);
    this.changeCalendarListView(false);
  }
  getAllDropDownForEntryManagement = (eventId) => {
    this.entryServices
      .getAllDropDownForEntryManagement(eventId)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let eventStatus = response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "Status"
          );
          eventStatus = eventStatus.map((p) => ({
            value: p.id,
            label: p.name,
          }));

          this.setState({ eventStatus: eventStatus }, () => {
            this.getEntryDetailList();
          });
        } else {
          this.swalServices.Error(response.message);
        }
      });
  };
  getEntryDetailList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.entryServices.getEntryDetailList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let eventArr = response.responseItem.responseContent.itemList;

        const swapValue = (details) => {
          Object.keys(details).forEach((key) => {
            if (details[key].eventDate !== null) {
              details[key].eventDate = moment(details[key].eventDate).format(
                "DD MMM YYYY"
              );
            }
          });
        };
        swapValue(eventArr);
        this.setState({
          eventList: eventArr,
          totalResultes: response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };
  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.pageSize = 10;
    detail.searchText = value;
    this.setState({ pagination: { ...detail } });

    //this.getEntryDetailList();
  };

  onEdit = (id) => {
    this.setState({ route: "/CreateEntry/eventId?=" + encryptAES(id) });
  };
 actionClick = (index, value, value2, option, event) => {
    if (option === "Cancel all bookings") {
      let found = this.state.eventList.find((event) => event.eventId && event.eventTimeSlotId === value2);
      if (found) {
        found.creditNoteMonth = moment();
        this.setState({ cancelBookingDetails: found }, () => {
          event.stopPropagation();
          this.setState({ setCancelAllBookingsModel: true });
        });
        this.getCancellationReasonForCreditNote();
      }
    }
    if (option === "Edit") {
      //event.stopPropagation();
      this.onEdit(value);
    }
    if (option === "Download Booking Reports") {
      let event = this.state.eventList.find((x) => x.eventId === value && x.eventTimeSlotId === value2);
      if (event) {
        if (
          event.eventId &&
          event.eventId > 0 &&
          event.booking &&
          Number(event.booking) > 0
        ) {  
          if (event.isSpecificEventType) {
            this.downloadBookingSheetByEventIdSpecificEvents(event.eventId, event.eventName, this.state.eventList[index].eventTimeSlotId);
          } else {
            this.downloadBookingSheetByEventId(event.eventId, event.eventName, this.state.eventList[index].eventTimeSlotId);
          }
        } else {
          this.swalServices.WarningWithOkAction(
            `Booking details is not available for ${event.eventName}.`
          );
        }
      }
    }
    if (option === "URL Link") {
      if (value > 0 && this.state.eventList.length > 0) {
        let data = this.state.eventList.find((x) => x.eventId === value && x.eventTimeSlotId === value2);
        if (data) {
          let host = WebPath;
          let urlLink = "";
          if (data.eventTypeName === "Conference") {
            urlLink = `${host}programmes/conferenceDetails/${encryptAES(
              data.eventId,
              0
            )}?timeSlot=${encryptAES(data.eventTimeSlotId)}`;
            window.open(urlLink, "_blank");
          } else if (data.eventTypeName === "Workshop" || data.eventTypeName === "Webinar" || data.eventTypeName === "Social Networking" || data.eventTypeName === "AML Course") {
            urlLink = `${host}programmes/workshopDetails/${encryptAES(
              data.eventId,
              0
            )}`;
            window.open(urlLink, "_blank");
          } else if (data.eventTypeName === "Surveys") {
            urlLink = `${host}programmes/formDetails/${encryptAES(
              data.eventId,
              0
            )}`;
            window.open(urlLink, "_blank");
          }
        }
      }
    }
    if (option === "Send Certificate") {
      let event = this.state.eventList.find((x) => x.eventId === value && x.eventTimeSlotId === value2);
      if (event) {
        if (
          event.eventId &&
          event.eventId > 0 &&
          event.attendeeCount &&
          Number(event.attendeeCount) > 0
        ) {
          this.setState({
            confirmModalOpen: true,
            selectedEvent: {
              eventId: event.eventId,
              eventTimeSlotId: this.state.eventList[index].eventTimeSlotId,
              attendeeCount: event.attendeeCount,
            },
          });
        }
        else {
          this.swalServices.WarningForEvent(
            `Unable to send certificates for ${event.eventName}.`
          );
        }
      }
    }
    else if (option === "Upload Booking Reports") {

      let found = this.state.eventList.find((event) => event.eventId && event.eventTimeSlotId === value2);
      if (found) {
        found.creditNoteMonth = moment();
        this.setState({ uploadBookingReports: found }, () => {
          event.stopPropagation();
          this.setState({ setUploadBookingReports: true });
        });
        // this.getCancellationReasonForCreditNote();
      }
    }
  };


  downloadBookingSheetByEventIdSpecificEvents = (eventId = 0, eventName = "Event", timeslotId = 0) => {
  this.setState({ isDownloadingExcel: true });
  if (eventId && eventId > 0) {
    let request = [];
    request.push(eventId);
    request.push(timeslotId);
    this.BookingServices.downloadBookingSheetByEventIdSpecificEvents(request).then(
      (response) => {
        if (response.status === 200 && response.data != null) {
          let blob = new Blob([response.data]);
          saveAs(blob, `${eventName}_Bookings` + ".xlsx");
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isDownloadingExcel: false });
      }
    );
  }
};

  AddEventCertificateInQueue = (eventId = 0, eventTimeSlotId = 0, attendeeCount = 0) => {
    if (eventId && eventId > 0) {
      const audit = getAuditContext()
      this.setState({ isSendingCertificates: true });
      let request = {};
      request.eventId = eventId;
      request.eventTimeSlotId = eventTimeSlotId;
      request.createdBy = audit.adminUserId;
      request.createdAppId = audit.appId;
      if (Number(attendeeCount) <= 0) {
        this.swalServices.WarningWithOkAction("No certificates available to send.");
      }
      else {
        this.financeService
          .addEventCertificateInQueue(request)
          .then((response) => {
            if (response.statusCode === 200) {
              let result = response.responseItem.responseContent;
              if (result.hasError) {
                this.swalServices.Alert(result.errorMessage);
              } else {
                this.swalServices.Success("Certificate sending has been queued successfully.");
              }
            } else {
              this.swalServices.Error("Something went wrong");
            }
          })
          .finally(() => {
            this.setState({ isSendingCertificates: false, confirmModalOpen: false, selectedEvent: null });
          });
      }
    }
  };

  downloadBookingSheetByEventId = (eventId = 0, eventName = "Event", timeslotId = 0) => {
    this.setState({ isDownloadingExcel: true });
    if (eventId && eventId > 0) {
      let request = [];
      request.push(eventId);
      request.push(timeslotId);
      this.BookingServices.downloadBookingSheetByEventId(request).then(
        (response) => {
          if (response.status === 200 && response.data != null) {
            // var filename = `${detail}${formattedDate}`;
            let blob = new Blob([response.data]);
            saveAs(blob, `${eventName}_Bookings` + ".xlsx");
          } else {
            this.swalServices.Error(response.message);
          }
          this.setState({ isDownloadingExcel: false });
        }
      );
    }
  };

  onTagging = (id) => {
    let event = this.state.eventList.find((x) => x.eventId === id);
    if (event) {
      if (event.status === "Draft") {
        this.swalServices.Error("Please submit the entry");
      } else {
        this.setState({
          route: "/CategoryCampaignTagging/eventId?=" + encryptAES(id),
        });
      }
    }
  };
  onDelete = (eventId, index, value, eventTimeSlotId) => {
    const audit = getAuditContext()
    let request = {
      eventId: eventId,
      eventTimeSlotId: eventTimeSlotId || 0,
      createdAppId:audit.appId,
      createdBy:audit.adminUserId
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "Entry"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "entry details"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.entryServices
            .deleteEntryDetailsByIds(request)
            .then((response) => {
              if (
                response.statusCode === 200 &&
                response.responseItem != null
              ) {
                this.swalServices.Success(
                  "Entry details deleted successfully."
                );
                this.getEntryDetailList();
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };

  handleChangeForCreditNote = (event, identity) => {
    let { name, value } = event.target;
    let detail = { ...this.state.cancelBookingDetails };
    if (identity === "CreditNote") {
      detail[name] = value;
      this.setState({ cancelBookingDetails: detail });
    }
  };

  getCancellationReasonForCreditNote = () => {
    this.financeService
      .getCancellationReasonForCreditNote()
      .then((response) => {
        if (
          response.statusCode === 200 &&
          response.responseItem.responseContent != null &&
          response.responseItem.responseContent.length > 0
        ) {
          let cancelReason = response.responseItem.responseContent;
          this.setState({ cancellationReason: cancelReason });
        } else {
          this.swalServices.Error(response.message);
        }
      });
  };

  setFilterParameters = (id, drpIdentity) => {
    let cancel_reason = this.state.cancellationReason;
    let data = { ...this.state.cancelBookingDetails };

    //let details = { ...this.state.corporateCreditNotePaymentInfo }
    let findData = cancel_reason.filter((x) => x.id === id);
    if (findData.length > 0) {
      data.cancellationReasonId = findData[0].id;
      if (findData[0].name === "Others") {
        data.cancellationReason = "";
        this.setState({ isOtherCancellationReason: true });
        //this.validateFinanceCreditNote("cancellationReasonId", data);
      } else {
        data.cancellationReason = findData[0].name;
        this.setState({ isOtherCancellationReason: false });
      }
    } else {
      data.cancellationReason = "";
      data.cancellationReasonId = 0;
      this.setState({ isOtherCancellationReason: false });
    }
    this.validateFinanceCreditNote("cancellationReasonId", data);
    this.setState({ cancelBookingDetails: data });
  };

  validateFinanceCreditNote = (key, providedState) => {
    providedState = providedState || this.state.cancelBookingDetails;
    const newValidState = validate(
      key,
      providedState,
      this.state.cancelBookingDetailsValidationRules,
      this.state.validCreditNote
    );
    this.setState({ validCreditNote: newValidState });
  };

  isValidFinanceCreditNote = () => {
    const newValidState = isValidForm(
      this.state.cancelBookingDetails,
      this.state.cancelBookingDetailsValidationRules,
      this.state.validCreditNote
    );
    this.setState({ validCreditNote: newValidState });
    return newValidState.isValid;
  };

  addFinanceCreditNote = () => {
    if (this.isValidFinanceCreditNote()) {
      let request = {
        EventId: this.state.cancelBookingDetails.eventId,
        EventTimeSlotId: this.state.cancelBookingDetails.eventTimeSlotId,
        IsEvent: true,
        CreditNoteMonth: this.state.cancelBookingDetails.creditNoteMonth,
        CreditNoteStatusId: 1,
        CreditNoteCancellationReason:
          this.state.cancelBookingDetails.cancellationReason,
        CreatedAppId: 114,
        CreatedAt: moment(),
        CreatedBy: 1,
      };
      this.financeService.addFinanceCreditNote(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (
            response.responseItem.responseContent.creditNoteNumber === "" &&
            response.responseItem.responseContent.errorMessage === null
          ) {
            this.swalServices.Error(
              ErrorMessage.NoRecordFound.replace("{0}", "Credit note")
            );
          } else if (
            response.responseItem.responseContent.errorMessage === ""
          ) {
            this.swalServices.Success(
              SuccessMessage.Insert_Success.replace("{0}", "Credit Note")
            );
          } else {
            this.swalServices.Error(
              ErrorMessage.Already_Exist.replace("{0}", "Credit note")
            );
          }
        } else {
          this.swalServices.Error(ErrorMessage.DefaultMessage);
        }
        this.setState({ isLoading: false });
      });
    }
  };

  filterByFeatured = (value, e) => {
    let pagination = this.state.pagination;
    pagination.isCalendarView = e.target.checked;
    this.setState({ pagination: pagination }, () => {
      this.getEntryDetailList();
    });
  };



  changeCalendarListView = (view) => {
    let pagination = this.state.pagination;
    pagination.isCalendarView = view;
    this.setState({ pagination: pagination }, () => {
      this.getEntryDetailList();
    });
  };

  onFileChange = (event, fileKey) => {
    const fileInput = event.target;
    const file = event.target.files[0];
    fileInput.value = "";
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel"
    ];

    if (file && allowedTypes.includes(file.type)) {
      let request = {};
      request.storagePath = "BookingReports";
      request.file = file;
      request.fileName = file.name;

      // Step 1: Upload file
      this.CommonServices.uploadBookingReportExcel(request).then((response) => {
        if (response != null) {
          // Step 2: Parse Excel rows here
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const isSpecificEvent =
                        this.state.uploadBookingReports?.isSpecificEventType;

                    const sheetName = isSpecificEvent
                        ? "Table Information"
                        : workbook.SheetNames[0];

            const worksheet = workbook.Sheets[sheetName];
            const excelJson = XLSX.utils.sheet_to_json(worksheet);

            // Step 3: Save file & parsedData in state
            const updatedDetails = {
              fileName: file.name,
              fullFilePath: response.fullFilePath,
              parsedData: excelJson
            };

            this.setState({ [fileKey]: updatedDetails }, () => {
              this.swalServices.Success("File Uploaded");
            });
          };
          reader.readAsArrayBuffer(file);
        } else {
          this.swalServices.Error(response.message);
        }
      });
    } else {
      this.swalServices.Error("Please select a valid file");
    }
  };

  UpdateFiles = () => {
    const { fileDetails } = this.state;
    const bookingList = fileDetails.parsedData;
    const isSpecificEvent = this.state.uploadBookingReports?.isSpecificEventType;
    if (!isSpecificEvent) {
    const missingTableNos = bookingList.filter(item => {
       const rawValue = item['Table Number'];
       const isTableEmpty =
        rawValue === undefined ||
        rawValue === null ||
        String(rawValue).trim() === "";

      const isCancelled = String(item['Booking Status']).toLowerCase() === "cancelled";
      return isTableEmpty && !isCancelled;
    });

    if (missingTableNos.length > 0) {
      this.swalServices.Error("Some Table Numbers are missing. Please update them before submitting.");
      this.setState({
        setUploadBookingReports: false,
        fileDetails: {
          fileName: "",
          fullFilePath: "",
        }
      });
      return;
    }
  }
   const bookingDetailsList = fileDetails.parsedData.map(item => {
    if (isSpecificEvent) {
        return {
            bookingId: item["BookingId"]
                ? Number(item["BookingId"])
                : null,
            tableNumber: item["TableNumbers"]
        };
    }

    return {
        bookingAttendeeInformationId: item["Booking Attendee Information Id"]
            ? Number(item["Booking Attendee Information Id"])
            : null,
        attendeeEmail: item["Email Address"] || null,
        tableNumber: item["Table Number"]
    };
});
    let request = {
      fileName: fileDetails.fileName,
      fullFilePath: fileDetails.fullFilePath,
      bookingDetailsList: bookingDetailsList
    };

   const updateApi = isSpecificEvent
  ? this.entryServices.updateBookingReportExcelForSpecificEvents
  : this.entryServices.updateBookingReportExcel;

   updateApi.call(this.entryServices, request).then((response) => {
      if (response.statusCode === 200) {
        this.swalServices.Success("Booking Report updated sucessfully!");
        this.setState({
          setUploadBookingReports: false,
          uploadBookingReports: {},
          fileDetails: {
            fileName: "",
            fullFilePath: "",
          }
        });
      } else {
        this.swalServices.Error(response.message);
      }
    });
  };

  handleConfirm = () => {
    const { selectedEvent } = this.state;
    if (selectedEvent) {
      this.addEventCertificateInQueue(selectedEvent.eventId, selectedEvent.eventTimeSlotId, selectedEvent.attendeeCount);
    }
  };

  handleClose = () => {
    this.setState({ confirmModalOpen: false, selectedEvent: null });
  };


  render() {
    if (this.state.route !== "") {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div
          className={`main-body-section 
          ${this.state.pagination.isCalendarView === true ? " hidden" : ""}`
          }
        >
          <div className="custom-card shadow-lg">
            <div className="filter-info grid grid-cols-12 gap-6">
              <div className="filter-types xl:col-span-5 lg:col-span-5 col-span-12 pr-12">
                <label
                  className="filter-lable block text-xl font-medium  mb-1 theme-color min-h-30"
                  htmlFor="default"
                >
                  Search by Event Name
                </label>
                <input
                  id="eventName"
                  name="eventName"
                  className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                  type="text"
                  onChange={(e) => this.searchByName(e.target.value)}
                />
              </div>
              <div className="filter-types xl:col-span-5 lg:col-span-5 col-span-12 pr-12">
                <label
                  className=" filter-lable block text-xl font-medium  mb-1 theme-color min-h-30"
                  htmlFor="default"
                >
                  Status
                </label>
                <Selector
                  options={this.state.eventStatus}
                  // isMulti
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  // components={{
                  //   Option,
                  // }}
                  onChange={this.handleChangeInDropdown.bind(this)}
                  allowSelectAll={false}
                  value={this.state.pagination.optionSelected}
                  drpIdentity="Status"
                />
              </div>
              <div className="filter-types xl:col-span-5 lg:col-span-5 col-span-12 pr-12">
                <label
                  className=" filter-lable block text-xl font-medium  mb-1 theme-color min-h-30"
                  htmlFor="default"
                >
                  Hidden
                </label>
                <Selector
                  options={this.state.hiddenOption}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={this.handleChangeInDropdown.bind(this)}
                  allowSelectAll={false}
                  value={this.state.hiddenOption.find(
                    (x) => x.label === this.state.pagination.hiddenSearch
                  )}
                  drpIdentity="Hidden"
                />
              </div>
              <div className="xl:col-span-2 lg:col-span-2 col-span-12">
                <div className="flex items-end justify-end h-full pb-1">
                  <button
                    className="btn btn-red text-white"
                    onClick={() => this.getEntryDetailList()}
                  >
                    <span className="text-xl text-white font-semibold tracking-normal">
                      Search
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Event list section start */}
          <div className="grid grid-cols-6 gap-4 pt-10 px-8">
            <h2 className="col-start-1 col-end-3 text-3xl font-bold text-[#757575]">
              {`Total:${this.state.eventList.length}`}
            </h2>
          </div>
          <main className="pb-10">
            <div className="w-full mx-auto">
              <div className="relative">
                <div>
                  <div className=" mt-6 view-edit-entries-tble table-content-wrap">
                    <Table
                      columns={[
                        { name: "eventName", title: "Event Name" },
                        { name: "eventDate", title: "Event Date" },
                        { name: "eventTypeName", title: "Type" },
                        // { name: "isHidden", title: "Hidden" },
                        { name: "attendeeCount", title: "Attendee" },
                        { name: "booking", title: "Booking" },
                        { name: "status", title: "Status" },
                        { name: "eventId", title: "Action" },
                      ]}
                      pagination={this.state.pagination}
                      rows={this.state.eventList}
                      sortingColumns={[
                        "eventName",
                        "eventDate",
                        "eventTypeName",
                      ]}
                      isLoading={this.state.isLoading}
                      totalResultes={this.state.totalResultes}
                      totalCount={this.state.totalResultes}
                      setPagination={this.setPagination.bind(this)}
                      customScope={[
                        {
                          column: "eventId",
                          renderTableData: this.actions.bind(this),
                        },
                        // {
                        //   // column: "eventId",
                        //   column:"eventTimeSlotId",
                        //   renderTableData: this.actions.bind(this),
                        // },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>

          <div className="generate-credit-note-popup">
            <CancelAllBookingsModel
              setCancelAllBookingsModel={this.state.setCancelAllBookingsModel}
              setOpenModal={() =>
                this.setState({ setCancelAllBookingsModel: false }, () => {
                  this.setState({ cancelBookingDetails: {} });
                })
              }
              onClose={(e) => {
                e.stopPropagation();
                this.setState({ setCancelAllBookingsModel: false }, () => {
                  this.setState({ cancelBookingDetails: {} });
                });
              }}
              handleChangeForCreditNote={this.handleChangeForCreditNote.bind(
                this
              )}
              cancelBookingDetails={this.state.cancelBookingDetails}
              addEdit={this.addFinanceCreditNote.bind(this)}
              cancellationReason={this.state.cancellationReason}
              setFilterParameters={this.setFilterParameters.bind(this)}
              isOtherCancellationReason={this.state.isOtherCancellationReason}
              validate={this.validateFinanceCreditNote.bind(this)}
              validCreditNote={this.state.validCreditNote}
            />


          </div>
          <div className="generate-credit-note-popup">
            <UploadBookingReports
              setUploadBookingReports={this.state.setUploadBookingReports}
              setOpenModal={() =>
                this.setState({ setUploadBookingReports: false }, () => {
                  this.setState({ uploadBookingReports: {} });
                })
              }
              onClose={(e) => {
                e.stopPropagation();
                this.setState({ setUploadBookingReports: false }, () => {
                  this.setState({ uploadBookingReports: {} });
                });
              }}
              fileDetails={this.state.fileDetails}
              onFileChange={this.onFileChange.bind(this)}
              updateFiles={this.UpdateFiles.bind(this)}
            />


          </div>
        </div>
        {/* Calendar Event Start */}
        {/* <div
          className={`event-calender-sec ${this.state.pagination.isCalendarView === false ? "hidden" : ""
            }`}
        >
          <EventCalender
            eventList={this.state.eventList}
            onTagging={this.onTagging.bind(this)}
            onDelete={this.onDelete.bind(this)}
            actionDropdown={this.state.actionDropdown}
            actionDropdown2={this.state.actionDropdown2}
            actionDropdown3={this.state.actionDropdown3}
            actionClick={this.actionClick.bind(this)}
          />
        </div> */}
        {/* Calendar Event End */}
        <ConfirmationModal
          isOpen={this.state.confirmModalOpen}
          onClose={this.handleClose}
          onConfirm={this.handleConfirm}
          title="Send Certificates"
          message="Confirm to send certificates to all attendees?"
          isLoading={this.state.isSendingCertificates}
        />
      </>
    );
  }
}
